import {getMethod, putMethod} from '~/api'

async function get(hotelId) {
    return await getMethod(`/api/hotelDescription/${hotelId}/checkin`)
}

async function put(hotelId, request) {
    return await putMethod(`/api/hotelDescription/${hotelId}/checkin`, request)
}

export {get, put}
